/* eslint-disable import/prefer-default-export */
import React from 'react';
import ContextSubMenu from 'Common/Components/ContextMenu/components/ContextSubMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import {
  setBulkUpdateField, setBulkUpdateValue, showContextMenu,
  updateVulnFromAsset
} from 'store/Contextualization/AssetDetail/actions';
import { useIntl } from 'react-intl';
import { MODAL_MANAGE_BULK_UPDATE_CONFIRMATION } from 'store/modals/modals';
import { openModal } from 'store/modals/actions';
import { StatusIcon } from './styled';

const StatusItem = ({ type }) => {
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const selectedVuln = vulnsSelected[0];
  const dispatch = useDispatch();
  const intl = useIntl();
  const oneVulnSelected = vulnsSelected.length === 1;
  const isBulk = vulnsSelected.length > 1;

  const applyStatus = (status) => {
    if (isBulk) {
      dispatch(setBulkUpdateField('status'));
      dispatch(setBulkUpdateValue(status));
      dispatch(openModal(MODAL_MANAGE_BULK_UPDATE_CONFIRMATION));
    } else dispatch(updateVulnFromAsset(selectedVuln, 'status', status));
    dispatch(showContextMenu(false));
  };

  return (
    <MenuItem
      isSelected={ oneVulnSelected && selectedVuln.status === type }
      title={ intl.formatMessage({ id: `manage.cm.status.${type}` }) }
      onClick={ () => applyStatus(type) }
    />
  );
};

export const Status = () => {
  const intl = useIntl();

  return (
    <ContextSubMenu
      title={ intl.formatMessage({ id: 'manage.cm.status' }) }
      icon={ <StatusIcon /> }
    >
      <StatusItem type="open" />
      <StatusItem type="closed" />
      <StatusItem type="re-opened" />
      <StatusItem type="risk-accepted" />
    </ContextSubMenu>
  );
};
